import { Injectable } from '@angular/core';
import { FilterModel } from '@ui/shared/util-filter';
import { Observable } from 'rxjs';
import { Result } from '@team23/ts-result';
import { ApiDataStatus } from '@ui/shared/util-api';

@Injectable()
export abstract class MapDataState<Item> {
    public abstract items$({ filters }: {
        filters: Map<string, FilterModel>;
    }): Observable<Result<Array<Item>, ApiDataStatus>>;

    public abstract reloadMapItems(): void;
}
